<template>
  <div class="block-header poppins row">
    <div :class="`${lg ? `col-lg-${lg}` : 'col-12'}`">
      <h1 class="block-header-name">
        {{ name | i18n }}
        <slot></slot>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockHeader',
  props: {
    name: {
      type: String,
      default: '',
    },
    lg: {
      type: String,
      default: '6',
    },
  },
};
</script>

<style lang="scss" scoped>
.block-header {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
}
.block-header-name {
  font-size: 20px;
  line-height: 30px;
  color: #2260FF;
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 0;
}
</style>
